import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import {useEffect} from "react"; 
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Reviews from "./pages/Reviews";

import Study from "./pages/Study";
import Tourism from "./pages/Tourism";
import Work from "./pages/Work";
import Conference from "./pages/Conference";

function App() {

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <Router>
      <ScrollToTop/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/reviews" element={<Reviews />} />

        <Route path="/study" element={<Study />} />
        <Route path="/tourism" element={<Tourism />} />
        <Route path="/work" element={<Work />} />
        <Route path="/conference" element={<Conference />} />
      </Routes>
    </Router>
  );
}

export default App;